var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-new"},[_c('div',{staticClass:"Page"},[_c('div',{staticClass:"leftMap"},[_c('div',{ref:"myEchart",staticStyle:{"position":"relative"},attrs:{"id":"chartChongqing"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }